import { useAuthStore } from '@/stores/auth.ts';
export class ExperimentsService {
    can(experimentType) {
        return Boolean(useAuthStore().experiments[experimentType]);
    }
}
export const experimentsService = new ExperimentsService();
